import {
    CONSTANT_DELIVERY_ADDRESS,
    CONSTANT_DELIVERY_TIME,
    CONSTANT_ORDER_TYPE,
    CONSTANT_ORDER_TYPE_DELIVERY,
    CONSTANT_ORDER_TYPE_DINEIN,
    CONSTANT_ORDER_TYPE_PICKUP,
    CONSTANT_SKIP_FIRST_STEP,
  } from "../../constans/strings.js";
  import {
    getCurrentDate,
    IsStoreOpenAtTime,
  } from "../../api/helpers/datetimeHelper";

  export class orderTypeHelper {
    static setOrderType(value) {
      sessionStorage.setItem(CONSTANT_ORDER_TYPE, value);
    }
    static setOrderTypePickup() {
      sessionStorage.setItem(CONSTANT_ORDER_TYPE, CONSTANT_ORDER_TYPE_PICKUP);
    }
    static setOrderTypeDelivery() {
      sessionStorage.setItem(CONSTANT_ORDER_TYPE, CONSTANT_ORDER_TYPE_DELIVERY);
    }
    static setOrderTypeDineIn() {
      sessionStorage.setItem(CONSTANT_ORDER_TYPE, CONSTANT_ORDER_TYPE_DINEIN);
    }
    static setSkipFirstStep(flag) {
      sessionStorage.setItem(CONSTANT_SKIP_FIRST_STEP, flag);
    }
    static getSkipFirstStep() {
      return sessionStorage.getItem(CONSTANT_SKIP_FIRST_STEP);
    }
    static isDelivery() {
      return (
        sessionStorage.getItem(CONSTANT_ORDER_TYPE) ===
        CONSTANT_ORDER_TYPE_DELIVERY
      );
    }
    static isPickup() {
      return (
        sessionStorage.getItem(CONSTANT_ORDER_TYPE) === CONSTANT_ORDER_TYPE_PICKUP
      );
    }
    static isDineIn() {
      return (
        sessionStorage.getItem(CONSTANT_ORDER_TYPE) === CONSTANT_ORDER_TYPE_DINEIN
      );
    }
    static getDeliveryAddress() {
      return sessionStorage.getItem(CONSTANT_DELIVERY_ADDRESS);
    }
    static getDeliveryTime() {
      return sessionStorage.getItem(CONSTANT_DELIVERY_TIME);
    }
    static setDeliveryAddress(value) {
      sessionStorage.setItem(CONSTANT_DELIVERY_ADDRESS, value);
    }
    static setDeliveryTime(value) {
      sessionStorage.setItem(CONSTANT_DELIVERY_TIME, value);
    }
    static removeOrderType() {
      sessionStorage.removeItem(CONSTANT_ORDER_TYPE);
    }
    static removeDeliveryAddress() {
      sessionStorage.removeItem(CONSTANT_DELIVERY_ADDRESS);
    }
    static clear() {
      sessionStorage.removeItem(CONSTANT_ORDER_TYPE);
      sessionStorage.removeItem(CONSTANT_DELIVERY_ADDRESS);
      sessionStorage.removeItem(CONSTANT_DELIVERY_TIME);
    }
    static getOrderType() {
      return sessionStorage.getItem(CONSTANT_ORDER_TYPE);
    }

    static storeSupportsDelivery(selectedCompany) {
      if(typeof selectedCompany !== 'object') {
        return;
      }

      var now = getCurrentDate(selectedCompany.TimezoneIanaFormat);
      
      var storeOpen = IsStoreOpenAtTime(
        selectedCompany.BlackoutDates,
        selectedCompany.OperatingHours,
        selectedCompany.IsInOperation,
        now
      );
      if (!selectedCompany.EnablePreoderForDelivery) {
        now = now.plus({
          minutes: selectedCompany.OrderPreparationTime,
        });
        storeOpen = IsStoreOpenAtTime(
          selectedCompany.BlackoutDates,
          selectedCompany.OperatingHours,
          selectedCompany.IsInOperation,
          now
        );
      }
      return (
        selectedCompany.ViewComponentConfigs &&
        selectedCompany.ViewComponentConfigs.Delivery &&
        (storeOpen || selectedCompany.EnablePreoderForDelivery)
      );
    }
    static storeSupportsDinein(selectedCompany) {
      if(typeof selectedCompany !== 'object') {
        return;
      }

      var now = getCurrentDate(selectedCompany.TimezoneIanaFormat);
      now = now.plus({
        minutes: selectedCompany.OrderPreparationTime,
      });
      var storeOpen = IsStoreOpenAtTime(
        selectedCompany.BlackoutDates,
        selectedCompany.OperatingHours,
        selectedCompany.IsInOperation,
        now
      );
      return selectedCompany.ViewComponentConfigs
        && selectedCompany.ViewComponentConfigs.EatIn
        && storeOpen;
    }
    static storeSupportsPickup(selectedCompany) {
      if(typeof selectedCompany !== 'object') {
        return;
      }

      var now = getCurrentDate(selectedCompany.TimezoneIanaFormat);
      var storeOpen = IsStoreOpenAtTime(
        selectedCompany.BlackoutDates,
        selectedCompany.OperatingHours,
        selectedCompany.IsInOperation,
        now
      );
      if (!selectedCompany.EnablePreoderForPickup) {
        now = now.plus({
          minutes: selectedCompany.OrderPreparationTime,
        });
        storeOpen = IsStoreOpenAtTime(
          selectedCompany.BlackoutDates,
          selectedCompany.OperatingHours,
          selectedCompany.IsInOperation,
          now
        );
      }
      return (
        selectedCompany.ViewComponentConfigs &&
        selectedCompany.ViewComponentConfigs.PickUp &&
        (storeOpen || selectedCompany.EnablePreoderForPickup)
      );
    }
  }
  